var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _path25, _path26, _path27, _path28, _path29, _g2, _path30, _g3, _path31, _g4, _path32, _g5, _path33, _g6, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDefaultService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5631 20.1506C24.5631 20.9819 23.8891 21.6559 23.0574 21.6559C22.2258 21.6559 21.5518 20.9819 21.5518 20.1506C21.5518 19.3191 22.2258 18.6453 23.0574 18.6453C23.8891 18.6453 24.5631 19.3191 24.5631 20.1506Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6684 4.91041C15.6684 5.74189 14.9944 6.41573 14.1627 6.41573C13.3312 6.41573 12.6572 5.74189 12.6572 4.91041C12.6572 4.07911 13.3312 3.40527 14.1627 3.40527C14.9944 3.40527 15.6684 4.07911 15.6684 4.91041Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3051 4.91017C20.3051 5.74165 19.6311 6.41548 18.7994 6.41548C17.9679 6.41548 17.2939 5.74165 17.2939 4.91017C17.2939 4.07886 17.9679 3.40503 18.7994 3.40503C19.6311 3.40503 20.3051 4.07886 20.3051 4.91017Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8329 8.74075C15.8329 9.65538 15.0913 10.3965 14.177 10.3965C13.2621 10.3965 12.5205 9.65538 12.5205 8.74075C12.5205 7.82612 13.2621 7.08521 14.177 7.08521C15.0913 7.08521 15.8329 7.82612 15.8329 8.74075Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.404 8.74107C20.404 9.60644 19.7024 10.3078 18.8368 10.3078C17.9712 10.3078 17.2695 9.60644 17.2695 8.74107C17.2695 7.87569 17.9712 7.17432 18.8368 7.17432C19.7024 7.17432 20.404 7.87569 20.404 8.74107Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7958 12.3885C15.7958 13.3031 15.0542 14.0444 14.1399 14.0444C13.2248 14.0444 12.4834 13.3031 12.4834 12.3885C12.4834 11.4738 13.2248 10.7329 14.1399 10.7329C15.0542 10.7329 15.7958 11.4738 15.7958 12.3885Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3649 12.3871C20.3649 13.2524 19.6634 13.9538 18.7978 13.9538C17.9322 13.9538 17.2305 13.2524 17.2305 12.3871C17.2305 11.5217 17.9322 10.8203 18.7978 10.8203C19.6634 10.8203 20.3649 11.5217 20.3649 12.3871Z",
    fill: "#17A7E0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7958 16.1082C15.7958 17.0228 15.0542 17.7637 14.1399 17.7637C13.2248 17.7637 12.4834 17.0228 12.4834 16.1082C12.4834 15.1936 13.2248 14.4526 14.1399 14.4526C15.0542 14.4526 15.7958 15.1936 15.7958 16.1082Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3649 16.1068C20.3649 16.9722 19.6634 17.6735 18.7978 17.6735C17.9322 17.6735 17.2305 16.9722 17.2305 16.1068C17.2305 15.2414 17.9322 14.54 18.7978 14.54C19.6634 14.54 20.3649 15.2414 20.3649 16.1068Z",
    fill: "#17A7E0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7958 19.8743C15.7958 20.7889 15.0542 21.5298 14.1399 21.5298C13.2248 21.5298 12.4834 20.7889 12.4834 19.8743C12.4834 18.9597 13.2248 18.2188 14.1399 18.2188C15.0542 18.2188 15.7958 18.9597 15.7958 19.8743Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3649 19.8744C20.3649 20.7397 19.6634 21.4411 18.7978 21.4411C17.9322 21.4411 17.2305 20.7397 17.2305 19.8744C17.2305 19.009 17.9322 18.3076 18.7978 18.3076C19.6634 18.3076 20.3649 19.009 20.3649 19.8744Z",
    fill: "#17A7E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7958 23.6067C15.7958 24.5213 15.0542 25.2626 14.1399 25.2626C13.2248 25.2626 12.4834 24.5213 12.4834 23.6067C12.4834 22.6921 13.2248 21.9512 14.1399 21.9512C15.0542 21.9512 15.7958 22.6921 15.7958 23.6067Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7958 27.3406C15.7958 28.2552 15.0542 28.9962 14.1399 28.9962C13.2248 28.9962 12.4834 28.2552 12.4834 27.3406C12.4834 26.426 13.2248 25.6851 14.1399 25.6851C15.0542 25.6851 15.7958 26.426 15.7958 27.3406Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3051 27.3411C20.3051 28.1726 19.6311 28.8464 18.7994 28.8464C17.9679 28.8464 17.2939 28.1726 17.2939 27.3411C17.2939 26.5098 17.9679 25.8359 18.7994 25.8359C19.6311 25.8359 20.3051 26.5098 20.3051 27.3411Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3649 12.3871C20.3649 13.2524 19.6634 13.9538 18.7978 13.9538C17.9322 13.9538 17.2305 13.2524 17.2305 12.3871C17.2305 11.5217 17.9322 10.8203 18.7978 10.8203C19.6634 10.8203 20.3649 11.5217 20.3649 12.3871Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3649 16.1068C20.3649 16.9722 19.6634 17.6735 18.7978 17.6735C17.9322 17.6735 17.2305 16.9722 17.2305 16.1068C17.2305 15.2414 17.9322 14.54 18.7978 14.54C19.6634 14.54 20.3649 15.2414 20.3649 16.1068Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3649 19.8744C20.3649 20.7397 19.6634 21.4411 18.7978 21.4411C17.9322 21.4411 17.2305 20.7397 17.2305 19.8744C17.2305 19.009 17.9322 18.3076 18.7978 18.3076C19.6634 18.3076 20.3649 19.009 20.3649 19.8744Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3051 23.6072C20.3051 24.4387 19.6311 25.1125 18.7994 25.1125C17.9679 25.1125 17.2939 24.4387 17.2939 23.6072C17.2939 22.7759 17.9679 22.1021 18.7994 22.1021C19.6311 22.1021 20.3051 22.7759 20.3051 23.6072Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6235 8.74107C24.6235 9.60644 23.922 10.3078 23.0564 10.3078C22.1908 10.3078 21.4893 9.60644 21.4893 8.74107C21.4893 7.87569 22.1908 7.17432 23.0564 7.17432C23.922 7.17432 24.6235 7.87569 24.6235 8.74107Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6235 12.3873C24.6235 13.2527 23.922 13.9541 23.0564 13.9541C22.1908 13.9541 21.4893 13.2527 21.4893 12.3873C21.4893 11.5219 22.1908 10.8206 23.0564 10.8206C23.922 10.8206 24.6235 11.5219 24.6235 12.3873Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6235 16.1068C24.6235 16.9722 23.922 17.6735 23.0564 17.6735C22.1908 17.6735 21.4893 16.9722 21.4893 16.1068C21.4893 15.2414 22.1908 14.54 23.0564 14.54C23.922 14.54 24.6235 15.2414 24.6235 16.1068Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8678 4.9108C23.8678 5.35956 23.504 5.72322 23.0551 5.72322C22.6063 5.72322 22.2422 5.35956 22.2422 4.9108C22.2422 4.46205 22.6063 4.09839 23.0551 4.09839C23.504 4.09839 23.8678 4.46205 23.8678 4.9108Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6119 1.38737C19.6119 1.83612 19.2481 2.19978 18.7993 2.19978C18.3504 2.19978 17.9863 1.83612 17.9863 1.38737C17.9863 0.938614 18.3504 0.574951 18.7993 0.574951C19.2481 0.574951 19.6119 0.938614 19.6119 1.38737Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_162_1164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 2,
    height: 3
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3262 0.5H14.9517V2.12472H13.3262V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_162_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9517 1.31242C14.9517 1.76117 14.588 2.12483 14.1391 2.12483C13.6903 2.12483 13.3262 1.76117 13.3262 1.31242C13.3262 0.863663 13.6903 0.5 14.1391 0.5C14.588 0.5 14.9517 0.863663 14.9517 1.31242Z",
    fill: "white"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4547 1.42545C10.4547 1.8742 10.0909 2.23787 9.64206 2.23787C9.1932 2.23787 8.8291 1.8742 8.8291 1.42545C8.8291 0.9767 9.1932 0.613037 9.64206 0.613037C10.0909 0.613037 10.4547 0.9767 10.4547 1.42545Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5484 16.1076C27.5484 16.5563 27.1847 16.92 26.7358 16.92C26.287 16.92 25.9229 16.5563 25.9229 16.1076C25.9229 15.6588 26.287 15.2952 26.7358 15.2952C27.1847 15.2952 27.5484 15.6588 27.5484 16.1076Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5484 12.3879C27.5484 12.8366 27.1847 13.2003 26.7358 13.2003C26.287 13.2003 25.9229 12.8366 25.9229 12.3879C25.9229 11.9391 26.287 11.5754 26.7358 11.5754C27.1847 11.5754 27.5484 11.9391 27.5484 12.3879Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5855 8.74064C27.5855 9.18939 27.2218 9.55305 26.7729 9.55305C26.3241 9.55305 25.96 9.18939 25.96 8.74064C25.96 8.29189 26.3241 7.92822 26.7729 7.92822C27.2218 7.92822 27.5855 8.29189 27.5855 8.74064Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_162_1164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 3,
    height: 2
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.738281 15.2937H2.36375V16.9185H0.738281V15.2937Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_162_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36385 16.1061C2.36385 16.5549 2.0001 16.9185 1.55124 16.9185C1.10238 16.9185 0.738281 16.5549 0.738281 16.1061C0.738281 15.6574 1.10238 15.2937 1.55124 15.2937C2.0001 15.2937 2.36385 15.6574 2.36385 16.1061Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_162_1164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 18,
    width: 3,
    height: 3
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.738281 18.9673H2.36375V20.5921H0.738281V18.9673Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_162_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36385 19.7797C2.36385 20.2285 2.0001 20.5921 1.55124 20.5921C1.10238 20.5921 0.738281 20.2285 0.738281 19.7797C0.738281 19.3309 1.10238 18.9673 1.55124 18.9673C2.0001 18.9673 2.36385 19.3309 2.36385 19.7797Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_162_1164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 18,
    width: 3,
    height: 3
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7471 18.9673H27.3725V20.5921H25.7471V18.9673Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_162_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3726 19.7797C27.3726 20.2285 27.0089 20.5921 26.56 20.5921C26.1112 20.5921 25.7471 20.2285 25.7471 19.7797C25.7471 19.3309 26.1112 18.9673 26.56 18.9673C27.0089 18.9673 27.3726 19.3309 27.3726 19.7797Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_162_1164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 3,
    height: 3
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.738281 11.5771H2.36375V13.202H0.738281V11.5771Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_162_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36385 12.3896C2.36385 12.8383 2.0001 13.202 1.55124 13.202C1.10238 13.202 0.738281 12.8383 0.738281 12.3896C0.738281 11.9408 1.10238 11.5771 1.55124 11.5771C2.0001 11.5771 2.36385 11.9408 2.36385 12.3896Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_162_1164",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 3,
    height: 3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.738281 7.92993H2.36375V9.55476H0.738281V7.92993Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_162_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.36385 8.74235C2.36385 9.1911 2.0001 9.55476 1.55124 9.55476C1.10238 9.55476 0.738281 9.1911 0.738281 8.74235C0.738281 8.29359 1.10238 7.92993 1.55124 7.92993C2.0001 7.92993 2.36385 8.29359 2.36385 8.74235Z",
    fill: "white"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37741 5.72297C4.92856 5.72297 4.56445 5.35931 4.56445 4.91056C4.56445 4.46181 4.92856 4.09814 5.37741 4.09814C5.82627 4.09814 6.19002 4.46181 6.19002 4.91056C6.19002 5.35931 5.82627 5.72297 5.37741 5.72297Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37741 24.3284C4.92856 24.3284 4.56445 23.9648 4.56445 23.516C4.56445 23.0673 4.92856 22.7036 5.37741 22.7036C5.82627 22.7036 6.19002 23.0673 6.19002 23.516C6.19002 23.9648 5.82627 24.3284 5.37741 24.3284Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0551 24.3282C22.6063 24.3282 22.2422 23.9645 22.2422 23.5158C22.2422 23.067 22.6063 22.7034 23.0551 22.7034C23.504 22.7034 23.8678 23.067 23.8678 23.5158C23.8678 23.9645 23.504 24.3282 23.0551 24.3282Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37741 28.1536C4.92856 28.1536 4.56445 27.79 4.56445 27.3412C4.56445 26.8925 4.92856 26.5288 5.37741 26.5288C5.82627 26.5288 6.19002 26.8925 6.19002 27.3412C6.19002 27.79 5.82627 28.1536 5.37741 28.1536Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0551 28.1539C22.6063 28.1539 22.2422 27.7902 22.2422 27.3415C22.2422 26.8927 22.6063 26.5291 23.0551 26.5291C23.504 26.5291 23.8678 26.8927 23.8678 27.3415C23.8678 27.7902 23.504 28.1539 23.0551 28.1539Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64206 31.8494C9.1932 31.8494 8.8291 31.4858 8.8291 31.037C8.8291 30.5883 9.1932 30.2246 9.64206 30.2246C10.0909 30.2246 10.4547 30.5883 10.4547 31.037C10.4547 31.4858 10.0909 31.8494 9.64206 31.8494Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7993 31.8114C18.3504 31.8114 17.9863 31.4477 17.9863 30.9989C17.9863 30.5502 18.3504 30.1865 18.7993 30.1865C19.2481 30.1865 19.6119 30.5502 19.6119 30.9989C19.6119 31.4477 19.2481 31.8114 18.7993 31.8114Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1772 35.5001C13.7284 35.5001 13.3643 35.1364 13.3643 34.6877C13.3643 34.2389 13.7284 33.8752 14.1772 33.8752C14.6261 33.8752 14.9898 34.2389 14.9898 34.6877C14.9898 35.1364 14.6261 35.5001 14.1772 35.5001Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37474 10.3078C4.50916 10.3078 3.80762 9.60644 3.80762 8.74107C3.80762 7.87569 4.50916 7.17432 5.37474 7.17432C6.24032 7.17432 6.94186 7.87569 6.94186 8.74107C6.94186 9.60644 6.24032 10.3078 5.37474 10.3078Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37474 13.9541C4.50916 13.9541 3.80762 13.2527 3.80762 12.3873C3.80762 11.5219 4.50916 10.8206 5.37474 10.8206C6.24032 10.8206 6.94186 11.5219 6.94186 12.3873C6.94186 13.2527 6.24032 13.9541 5.37474 13.9541Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37677 17.6125C4.54509 17.6125 3.87109 16.9387 3.87109 16.1072C3.87109 15.2759 4.54509 14.6021 5.37677 14.6021C6.20827 14.6021 6.88227 15.2759 6.88227 16.1072C6.88227 16.9387 6.20827 17.6125 5.37677 17.6125Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37677 21.3789C4.54509 21.3789 3.87109 20.705 3.87109 19.8737C3.87109 19.0422 4.54509 18.3684 5.37677 18.3684C6.20827 18.3684 6.88227 19.0422 6.88227 19.8737C6.88227 20.705 6.20827 21.3789 5.37677 21.3789Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64435 6.45235C8.81267 6.45235 8.13867 5.77851 8.13867 4.94721C8.13867 4.11573 8.81267 3.44189 9.64435 3.44189C10.4758 3.44189 11.1498 4.11573 11.1498 4.94721C11.1498 5.77851 10.4758 6.45235 9.64435 6.45235Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6433 10.3444C8.77771 10.3444 8.07617 9.64306 8.07617 8.77769C8.07617 7.91231 8.77771 7.21094 9.6433 7.21094C10.5089 7.21094 11.2104 7.91231 11.2104 8.77769C11.2104 9.64306 10.5089 10.3444 9.6433 10.3444Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6433 13.9921C8.77771 13.9921 8.07617 13.2908 8.07617 12.4254C8.07617 11.56 8.77771 10.8586 9.6433 10.8586C10.5089 10.8586 11.2104 11.56 11.2104 12.4254C11.2104 13.2908 10.5089 13.9921 9.6433 13.9921Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6433 17.7119C8.77771 17.7119 8.07617 17.0105 8.07617 16.1451C8.07617 15.2797 8.77771 14.5784 9.6433 14.5784C10.5089 14.5784 11.2104 15.2797 11.2104 16.1451C11.2104 17.0105 10.5089 17.7119 9.6433 17.7119Z",
    fill: "#17A7E0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6433 21.4284C8.77771 21.4284 8.07617 20.727 8.07617 19.8617C8.07617 18.9963 8.77771 18.2949 9.6433 18.2949C10.5089 18.2949 11.2104 18.9963 11.2104 19.8617C11.2104 20.727 10.5089 21.4284 9.6433 21.4284Z",
    fill: "#17A7E0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6433 25.1638C8.77771 25.1638 8.07617 24.4624 8.07617 23.597C8.07617 22.7316 8.77771 22.0303 9.6433 22.0303C10.5089 22.0303 11.2104 22.7316 11.2104 23.597C11.2104 24.4624 10.5089 25.1638 9.6433 25.1638Z",
    fill: "#17A7E0"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64435 28.8349C8.81267 28.8349 8.13867 28.1611 8.13867 27.3296C8.13867 26.4983 8.81267 25.8245 9.64435 25.8245C10.4758 25.8245 11.1498 26.4983 11.1498 27.3296C11.1498 28.1611 10.4758 28.8349 9.64435 28.8349Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6433 17.7119C8.77771 17.7119 8.07617 17.0105 8.07617 16.1451C8.07617 15.2797 8.77771 14.5784 9.6433 14.5784C10.5089 14.5784 11.2104 15.2797 11.2104 16.1451C11.2104 17.0105 10.5089 17.7119 9.6433 17.7119Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6433 21.4284C8.77771 21.4284 8.07617 20.727 8.07617 19.8617C8.07617 18.9963 8.77771 18.2949 9.6433 18.2949C10.5089 18.2949 11.2104 18.9963 11.2104 19.8617C11.2104 20.727 10.5089 21.4284 9.6433 21.4284Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6433 25.1638C8.77771 25.1638 8.07617 24.4624 8.07617 23.597C8.07617 22.7316 8.77771 22.0303 9.6433 22.0303C10.5089 22.0303 11.2104 22.7316 11.2104 23.597C11.2104 24.4624 10.5089 25.1638 9.6433 25.1638Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1385 32.504C13.3068 32.504 12.6328 31.8302 12.6328 30.9987C12.6328 30.1674 13.3068 29.4934 14.1385 29.4934C14.9702 29.4934 15.6442 30.1674 15.6442 30.9987C15.6442 31.8302 14.9702 32.504 14.1385 32.504Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDefaultService);
export default __webpack_public_path__ + "static/media/ic-default-service.35396d5181592578b21fbcf3a2226183.svg";
export { ForwardRef as ReactComponent };